import { defineMessages } from '@jutro/locale';

export default defineMessages({
    loading: {
        id: 'endorsement.pa.esignature.templates.Loading',
        defaultMessage: 'Loading...',
    },
    wantToDiscardPolicyChange: {
        id: 'endorsement.pa.esignature.templates.Want to discard your policy change?',
        defaultMessage: 'Want to discard your policy change?'
    },
    discardAllChanges: {
        id: 'endorsement.pa.esignature.templates.DISCARD ALL CHANGES',
        defaultMessage: 'DISCARD ALL CHANGES'
    },
    policies: {
        id: 'endorsement.pa.esignature.templates.Policies',
        defaultMessage: 'Policies'
    },
    discardChangesTemplate: {
        id: 'endorsement.pa.esignature.templates.Click discard all changes',
        defaultMessage: 'Click {strongName1} below to return to the {strongName2} page'
    },
    additionalRequiredSignatures: {
        id: 'endorsement.pa.esignature.templates.Additional Required Signatures',
        defaultMessage: 'Additional required signatures are needed for your policy change.  An Email has been sent to the additional signers requesting completion of the signature process.'

    },
    continue: {
        id: 'endorsement.pa.esignature.templates.Continue',
        defaultMessage: 'CONTINUE'
    },
    clickContinue: {
        id: 'endorsement.pa.esignature.templates.Click Continue to sign and finish your policy change',
        defaultMessage: 'Click {continue} to sign and finish your policy change.'
    },
    entryPopupTitle: {
        id: 'endorsement.pa.esignature.templates.You\'re almost done',
        defaultMessage: 'You\'re almost done'
    },
    exitPopupTitle: {
        id: 'endorsement.pa.esignature.templates.Finish later...',
        defaultMessage: 'Finish later...'
    },
    exitPopupSubtitle: {
        id: 'endorsement.pa.esignature.templates.Finish review and sign documents later',
        defaultMessage: 'You can finish reviewing and sign your documents later'
    },
    signBelowToCompletePolicyChange: {
        id: 'endorsement.pa.esignature.templates.Sign below to complete your policy change',
        defaultMessage: 'Sign below to complete your policy change'
    }

})